import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from "i18next-browser-languagedetector";
import backend from 'i18next-http-backend';

import HttpClient from "./helpers/httpClient";

const backendOptions = {
    loadPath: '{{lng}}|{{ns}}',
    request: async (_options, url, _payload, callback) => {
        var callBackData = {
            status: 500
        };

        try {
            const [lng] = url.split('|');

            const response = await HttpClient.send(process.env.REACT_APP_LOCALE_API + "/" + lng + "/apps/portal");

            if (response.ok) {
                const objResponse = await response.json();
                callBackData.data = objResponse.results;
                callBackData.status = 200;
            }
        } catch (e) {
            console.error(e);
        }

        callback(null, callBackData);
    }
};

let defaultLanguage =  localStorage.getItem("i18nextLng") ?? 'es';
console.info(defaultLanguage);

i18n
    .use(LanguageDetector)
    .use(backend)
    .use(initReactI18next)
    .init({
        backend: backendOptions,
        fallbackLng: defaultLanguage,
        lng: defaultLanguage,
        debug: process.env.REACT_APP_ENV !== "production",
        load: "languageOnly",
        initImmediate: true,
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        },
        useSuspense: true,
        react: {
            wait: false,
            bindI18n: 'languageChanged',
            bindStore: 'added',
            nsMode: 'default',
            useSuspense: true,
        }
    });

export default i18n;
